export type ReactVideoListProps = {
  videoProductList: VideoProductListProps[]
  videoIcon: string
  videoAltTxt: string
  ruleExpression: string
  headline: string
  description: string
  activePip: boolean
  inActivePip: boolean
  activeAuthoredIndex: number
  nextButton: string
  previousButton: string
  maxVideos: number
  hidedescription: boolean
  eyebrow: string
  displaytype: VideoDisplayType
  playlistview: VideoListType
  isInEditor?: boolean
}

export type VideoItem = {
  snippet: {
    playlistId: string
    resourceId: {
      kind: string
      videoId: string
    }
    publishedAt: string
    description: string
    position: number
    title: string
    thumbnails: {
      default: {
        width: number
        url: string
        height: number
      }
      high: {
        width: number
        url: string
        height: number
      }
      medium: {
        width: number
        url: string
        height: number
      }
    }
    channelId: string
    videoOwnerChannelId: string
    channelTitle: string
    videoOwnerChannelTitle: string
  }
  kind: string
  etag: string
  id: string
}

export type VideoProductListProps = {
  productcategory: string
  playlistid: string
}

export enum ReactVideoListDesignTokens {
  EYEBROW1 = 'cox-text-eyebrow1',
  EYEBROW2 = 'cox-text-eyebrow2',
  EYEBROW3 = 'cox-text-eyebrow3',
  INTERACTIVE1 = 'cox-text-interactive1',
  INTERACTIVE2 = 'cox-text-interactive2',
  INTERACTIVE3 = 'cox-text-interactive3'
}

export enum VideoDisplayType {
  WITH_DROPDOWN = 'homepage',
  WITHOUT_DROPDOWN = 'landingpage',
  BROWSE_ALL = 'browseall'
}

export enum VideoListType {
  CAROUSEL = 'carousel',
  GRID = 'grid'
}
